import React, { useState } from 'react';
import styles from '../../styles.module.scss';
import { useVendorPointSolutionContext } from '../vendor-solution-provider';
import toastr from '../../utils/toastr';
import { useMutation } from '@apollo/client';
import CREATE_MULTIPLE_VENDOR_PROGRAM from '../../mutation/create-multiple-vendor-program.graphql';
import VendorProgramList from '../vendor-program/vendor-program-list';

const VendorProgramMultipleContainer = ({ initialVendorProgramList = [], ...props }) => {
  const {
    setSelectedListOrg,
    selectedListOrg,
    categories,
    vendorPoints
  } = useVendorPointSolutionContext();

  const [vendorProgramList, setVendorProgramList] = useState(initialVendorProgramList);

  const [callCreateMultipleVendorProgram] = useMutation(CREATE_MULTIPLE_VENDOR_PROGRAM, {
    onCompleted: data => {
      const { success, errors } = data.createMultipleVendorProgram;
      if (success) {
        toastr.success('Created vendor programs successfully');
        handleClearData();
      } else {
        toastr.error(errors.join('\n'));
      }
    },
    onError: e => {
      console.log(e);
      toastr.error('Something went wrong');
    }
  });

  const handleClearData = () => {
    setVendorProgramList([]);
    setSelectedListOrg([]);
  };

  const handleSubmitData = async () => {
    const listEntityId = selectedListOrg.map(org => org.organization_id.toString());

    const vendorProgramParams = vendorProgramList.map(item => ({
      vendorId: item.vendorId,
      categoryCode: item.categoryCode,
      effectiveStartDate: item.effectiveStartDate,
      description: item.description,
      contact: item.contact,
      website: item.website
    }));

    await callCreateMultipleVendorProgram({
      variables: {
        listEntityId: listEntityId,
        listVendorProgramParams: vendorProgramParams
      }
    });
  };

  const handleCreateVendorProgram = values => {
    const { categoryCode, vendorId } = values;
    const { category, vendor } = getCategoryAndVendor(categoryCode, vendorId);

    const vendorProgram = {
      ...values,
      categoryName: category.name,
      vendorName: vendor.vendorNm,
      vendorProgramId: Date.now().toString(36)
    };

    setVendorProgramList(prev => [...prev, vendorProgram]);
  };

  const handleDeleteVendorProgram = vendorProgram => {
    const updatedVendorProgram = vendorProgramList.filter(item => item.vendorProgramId !== vendorProgram.vendorProgramId);

    setVendorProgramList(updatedVendorProgram);
  };

  const handleEditVendorProgram = (values, vendorProgram) => {
    const { categoryCode, vendorId } = values;
    const { category, vendor } = getCategoryAndVendor(categoryCode, vendorId);

    const updatedVendorProgram = {
      ...values,
      categoryName: category.name,
      vendorName: vendor.vendorNm,
      vendorProgramId: Date.now().toString(36)
    };

    const updatedVendorProgramList = vendorProgramList.map(item => {
      if (item.vendorProgramId === vendorProgram.vendorProgramId) return updatedVendorProgram;
      return item;
    });

    setVendorProgramList(updatedVendorProgramList);
  };

  const getCategoryAndVendor = (categoryCode, vendorId) => {
    const category = categories.find(category => category.masterCodeCd === categoryCode);
    const vendor = vendorPoints.find(vendor => vendor.vendorId.toString() === vendorId);
    return { category, vendor };
  };

  return (
    <div className={styles.vendorProgramList}>
      <VendorProgramList
        vendorPrograms={vendorProgramList}
        onEditVendorProgram={handleEditVendorProgram}
        onDeleteVendorProgram={handleDeleteVendorProgram}
        onCreateVendorProgram={handleCreateVendorProgram}
        isGroup={false}
        {...props}
      />
      <div className={styles.buttonSection}>
        <button className='button' onClick={handleSubmitData} disabled={vendorProgramList.length === 0}>Apply</button>
        <button className='button' onClick={handleClearData}>Clear</button>
      </div>
    </div>
  );
};

export default VendorProgramMultipleContainer;
